 <div class="row">
     <div class="col-lg-12">
         <div class="m-content">
             <div class="row">
                 <div class="col-lg-12" style="padding-bottom: 5px;">
                     <div>
                         <div *ngIf="showHeader">
                             <h1 class="login-page-title accent-text ">
                               {{'CHANGE_PASSWORD' | dictionary}}
                             </h1>
                         </div>
                         <div class="pt-0 pb-0">
                             <form class="login-block">
                                 <div class="m-portlet__body">

                                     <div class="form-group pb-3">
                                         <input type="password" [(ngModel)]="userProfile.OldPassword"
                                             class="form-control home-login-input-text" name="username"
                                             placeholder="{{'OLD_PASSWORD' | dictionary}}" (keyup.enter)="submit()" />
                                     </div>

                                     <div class="form-group pb-3">
                                         <input type="password" [(ngModel)]="userProfile.Password"
                                             class="form-control home-login-input-text" name="username"
                                             placeholder="{{'NEW_PASSWORD' | dictionary}}" (keyup.enter)="submit()" />
                                     </div>

                                     <div class="form-group pb-3">
                                         <input type="password" [(ngModel)]="userProfile.ConfirmPassword"
                                             class="form-control home-login-input-text" name="username"
                                             aria-describedby="emailHelp" placeholder="{{'CONFIRM_PASSWORD' | dictionary}}"
                                             (keyup.enter)="submit()" />
                                     </div>

                                     <div class="form-group text-center ">
                                         <button (click)="submit()"
                                             class="button-1 mr-10">
                                           {{'SAVE' | dictionary}}
                                         </button>
                                         <button (click)="cancel()"
                                             class="button-1">
                                           {{'CANCEL' | dictionary}}
                                         </button>

                                     </div>

                                     <div class="form-group" style="font-size: 14px;padding-left: 5px;">
                                         <small class="form-text text-center">
                                           {{'PASSWORD_REQUIREMENTS_SHORT' | dictionary}}:
                                         </small>
                                         <small class="form-text text-center">
                                             <span>*</span> {{'YOU_CAN_NOT_ENTER_CURRENT_PASSWORD' | dictionary}}
                                         </small>
                                         <small class="form-text text-center">
                                             <span>*</span>{{'AT_LEAST_CHARACTERS' | dictionary : 8}}
                                         </small>
                                         <small class="form-text text-center">
                                             <span>*</span>{{'ALPHA_NUMERIC_SPECIAL' | dictionary}}
                                         </small>
                                     </div>

                                 </div>
                             </form>

                         </div>
                     </div>
                 </div>
             </div>
         </div>
     </div>
     <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
     </app-pop-up-dialog>
 </div>
